"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areUint8ArraysEqual = void 0;
const areUint8ArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
        return false;
    }
    // start comparison from the end of the array as the first several hundreds of items in those array
    // will likely be identitical for most of tile images
    for (let i = arr1.length - 1; i >= 0; i--) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }
    return true;
};
exports.areUint8ArraysEqual = areUint8ArraysEqual;
//# sourceMappingURL=unit8array.js.map